

































































import {Prop} from "vue-property-decorator";
import {Component, Vue} from '@/shared/component';

import storeTemp from '@/stores/modules/temp';

import CrudList from '@/components/Crud/List.vue';
import TableHead from '@/components/Paginate/TableHead.vue';
import Checked from '@/components/Checked.vue';
import TableCell from '@/components/Paginate/TableCell.vue';
import {Temp, Token, User} from "@/models";
import {createStore} from "devextreme-aspnet-data-nojquery";
import {Stored} from "vue-stored-prop-decorator";
import storeToken from "@/stores/modules/token";
import CrudDeleteDialog from "@/components/Crud/DeleteDialog.vue";
import CrudTempEditDialog from "@/components/Crud/Temp/EditDialog.vue";

import DxScheduler, { DxResource } from 'devextreme-vue/scheduler';
import DxButton from "devextreme-vue/button";
import CustomStore from "devextreme/data/custom_store";
import storeUser from "@/stores/modules/user";

@Component({
	components: {
		CrudList, TableHead, TableCell, Checked,
		CrudDeleteDialog, CrudTempEditDialog,
		DxScheduler, DxResource, DxButton,
	}
})
export default class CrudTempAgenda extends Vue {

	@Prop({type: Boolean, default: true  }) private paginate;
	@Prop({type: Boolean, default: false }) private dense;
	@Stored(() => storeToken) token!: Token;

	private storeTemp = storeTemp;

	private editTemp: Temp = null;
	private deletedTemp: Temp = null;

	private views = ['agenda']
	private scheduler = null;
	private storeUser = storeUser;
	private users = null;
	private user = null;
	private option = null;

	private	date = this.mondayDate(new Date());

	public async mounted() {
		if (this.isGranted('API_GET_USER')) {
			await storeUser.dispatch('getC')
			this.users = storeUser.state.users.data
		}
	}

	private mondayDate(d) {
		d = new Date(d);
		let day = d.getDay(),
			diff = d.getDate() - day + (day == 0 ? -6:1); // adjust when day is sunday
		return new Date(d.setDate(diff));
	}

	private handleErrors(response) {
		if (!response.ok) {
			throw Error(response.statusText);
		}
		return response;
	}
	onContentReady(e) {
		this.scheduler = e.component;
	}

	private getUser() {
		return this.user;
	}

	private customDataSource = new CustomStore({
		key: 'Id',
		load: (options) => {
			return fetch(`${process.env.VUE_APP_BACK_BASE_URL}/api/temps/planning?filter=${ JSON.stringify(options['filter']) }&user=${this.getUser()}`, {
				headers:{
					'Authorization': 'BEARER ' + this.token.id
				}
			})
				.then(this.handleErrors)
				.then(response => response.json())
				.catch(() => { throw 'Network error' });
		},
		remove: (data) => {
			return fetch(`${process.env.VUE_APP_BACK_BASE_URL}/api/temps/${encodeURIComponent(data)}`, {
				method: 'DELETE',
				headers:{
					'Authorization': 'BEARER ' + this.token.id
				}
			})
				.then(this.handleErrors)
				.catch(() => { throw 'Network error' });
		},
		update: (key, values) => {
			return fetch(`${process.env.VUE_APP_BACK_BASE_URL}/api/temps/planning/${encodeURIComponent(key)}`, {
				method: 'PUT',
				body: JSON.stringify(values),
				headers:{
					'Content-Type': 'application/json',
					'Authorization': 'BEARER ' + this.token.id
				}
			})
				.then(this.handleErrors)
				.catch(() => { throw 'Network error' });
		}
	});
	private closedDialog() {
		this.scheduler.getDataSource().reload();
	}
	private async onAppointmentFormOpening (e): Promise<void> {
		e.cancel = true;
		if (e.appointmentData.id) {
			await storeTemp.dispatch('get', e.appointmentData.id)
			this.editTemp = this.storeTemp.state.temp
		} else {
			let temp = new Temp()
			temp.date = e.appointmentData.date.substr(0,10)
			this.editTemp = temp;
		}
	}

}
